import { useAPI } from '../../state';
var CANCEL_SIMULATION = '/api/report/simulation/cancel-simulation/{basePlanId}/{id}';
export var useCancelSimulation = function (id, basePlanId) {
    return useAPI(CANCEL_SIMULATION, { basePlanId: basePlanId, id: id }, 'POST');
};
